export interface Testimonial {
  quote: string
  author: string
  role: string
  program: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend 4-5 hours every Sunday planning sessions from different sources. Now I choose the event, choose the level, and I have a complete session ready to print and bring to the track. My Sundays are mine again.',
    author: 'Mike S.',
    role: 'High School Coach, USA',
    program: 'Track & Field Coach, State Championship Program',
  },
  {
    quote:
      'The biggest shift was having progressions instead of random drills. When an athlete’s approach breaks down, I know exactly what progression to use next. Before, I was just adding more attempts and hoping.',
    author: 'Sarah M.',
    role: 'Club Coach, UK',
    program: 'Athletics Director, Regional Squad',
  },
  {
    quote:
      'Managing 60+ athletes across 8 events used to be chaos. The mixed-group organization and station rotation system changed everything. Now every athlete knows where to go, what to do, and why it matters.',
    author: 'James L.',
    role: 'High School Coach, Australia',
    program: 'Track & Field Program Director',
  },
  {
    quote:
      'The low-resource adaptations were game-changing. My school doesn’t have a professional track, but the system shows me how to use grass, cones, and a stopwatch to train at the same level.',
    author: 'David K.',
    role: 'PE Teacher & Coach, USA',
    program: 'School Track Program',
  },
  {
    quote:
      'Competition week management went from stressful to systematic. The checklists, warm-up protocols, and timing plans mean I’m not reacting all day—I’m leading.',
    author: 'Emma R.',
    role: 'University Coach, Canada',
    program: 'University Athletics Program',
  },
]
